import { HTTP_METHOD_GET, HTTP_METHOD_POST } from '../../constants/httpMethod';
import { CREATE_ORDER_URL, PAY_URL, CAPTURE_URL, DETAILS_URL } from './constants';

export const createOrder = async (token, partnerId, phoneNumber, fixedFacialValue) => {
    const urlPhoneNumber = phoneNumber ? phoneNumber.replace('+', '%2B') : null;
    let url = `${CREATE_ORDER_URL}?partnerId=${partnerId}`;
    url = urlPhoneNumber ? url.concat(`&phoneNumber=${urlPhoneNumber}`) : url;
    url = url.concat(`&fixedFacialValue=${fixedFacialValue}`);

    try {
        const response = await fetch(url, {
            headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${token}`
            },
            method: HTTP_METHOD_POST
        });

        if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
        }

        const res = await response.json();
        return res.payload;
    } catch (error) {
        console.error('Error while creating order:', error);
        throw error;
    }
};

export const createPaypalOrder = async (token, userInfo, partnerId, orderId) => {
    try {
        const response = await fetch(PAY_URL, {
            headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${token}`
            },
            method: HTTP_METHOD_POST,
            body: JSON.stringify({ ...userInfo, partnerId, orderId })
        });

        const res = await response.json();
        return res.payload.widgetLink;
    } catch (error) {
        console.error('Failed to create PayPal order :', error);
        throw error;
    }
};

export const capturePaypalOrder = async (token, paypalOrderId, userInfo, partnerId) => {
    try {
        const response = await fetch(`${CAPTURE_URL}/${paypalOrderId}`, {
            headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${token}`
            },
            method: HTTP_METHOD_POST,
            body: JSON.stringify({ ...userInfo, partnerId })
        });

        const res = await response.json();
        return { status: response.status, ...res };
    } catch (error) {
        console.error('Failed to confirm PayPal order :', error);
        throw error;
    }
};

export const getPaypalOrderState = async paypalOrderId => {
    let plebicardUrl = `${DETAILS_URL.replace('%orderId%', paypalOrderId)}`;

    try {
        const response = await fetch(plebicardUrl, {
            headers: {
                'Content-Type': 'application/json'
            },
            method: HTTP_METHOD_GET
        });

        const res = await response.json();
        return { ...res };
    } catch (error) {
        console.error('Failed to get PayPal order details :', error);
        throw error;
    }
};



// WEBPACK FOOTER //
// ./src/services/paypal/utils.js